import { render, staticRenderFns } from "./ViewTariffPage.vue?vue&type=template&id=400b1ac1&"
import script from "./ViewTariffPage.vue?vue&type=script&lang=js&"
export * from "./ViewTariffPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewTariffPage.vue?vue&type=style&index=0&id=400b1ac1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports